import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  CardHeader,
  CardContent,
  Box,
  Card,
  Divider,
  useTheme,
  colors,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import { Line, Bar } from "react-chartjs-2";
import Page from "components/Page";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { Header, Tabla, ModalFormulario, ModalGeneral } from "components";
import Cancelar from "./Cancelar";
import { useForm } from "react-hook-form";
import getErrorMessage from "utils/getErrorMessage";
import Propuesta from "./Propuesta";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import serviciosCatalogo from "utils/serviciosCatalogo";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Indicadores = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const [ctl, setCtl] = useState({ grupos: [] });
  const [modalCancelar, setModalCancelar] = useState({ open: false });
  const { register, handleSubmit, errors, watch, setValue, reset } = useForm();

  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () =>
    setMAdvertencia({ ...mAdvertencia, open: false });
  const cerrarModalCancelar = () =>
    setModalCancelar({ ...modalCancelar, open: false });
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  };

  const clickCancelar = (item) => {
    setModalCancelar({
      open: true,
      width: "sm",
      paddingDisabled: true,
      titulo: "CANCELACIÓN DE SOLICITUD #" + item.idsolicitud,
      Formulario: Cancelar,
      item: { ...item, observacion: "", replicar: false },
    });
  };
  const clickPropuesta = (item) => {
    let propModal = {
      titulo: "GENERAR PROPUESTA DE GERENTE",
      tipo: 0,
      // mensaje:"¿Está seguro de enviar su Vo.Bo para la orden de compra " + item['folio'] + "?"
    };
    // if(item.idvbueno != null)
    //   propModal={
    //     titulo: "Autorizar orden de compra",
    //     tipo: 1,
    //     mensaje: "¿Está seguro de autorizar la orden de compra " + item['folio'] + "?"
    //   }
    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "lg",
      paddingDisabled: true,
      Formulario: Propuesta,
      guardar: guardarPropuesta,
      ...propModal,
    });
  };

  const guardarPropuesta = (data) => {
    // serviciosOrden.ordenAutorizar(respuesta(cerrarModal), setCargando, {
    //   folio: item.folio,
    //   idautoriza: "1",
    //   tipoAutoriza: item.idvbueno != null,

    // });
    console.log(data);
  };

  const cambioEstatus = (item) => (event) => {
    // serviciosOrden.ordenAutorizar(respuesta(cerrarModal), setCargando, {
    //   folio: item.folio,
    //   idautoriza: "1",
    //   tipoAutoriza: item.idvbueno != null,

    // });
    console.log(item);
  };

  useEffect(() => {
    
    serviciosCatalogo.gruposAll(
      (data) => {
        setCtl({ ...ctl, grupos: data });
      },
      setCargando,
      {}
    );
  }, []);

  const cancelarSolicitud = (data) => {
    let idsolicitud = modalCancelar.item.idsolicitud;
    serviciosSolicitudes.cancelarSolicitud(
      respuesta(cerrarModalCancelar),
      setCargando,
      { ...data, idsolicitud }
    );
  };
  const opcionesgrupo = [];
  useEffect(() => {
    serviciosSolicitudes.getSolicitudes(
      (data) => {
        setData(data.solicitudes);
      },
      setCargando,
      {}
    );
  }, []);

  const acciones = []; // { label: "Nueva orden", icon: <AddBox />, click: clickNuevo, disabled: !permisos.crear },
  const accionesFila = [
    {
      label: "Cancelar",
      onClick: clickCancelar,
      enabled: (item) => ["0"].includes(item.idestatus),
    },
    { label: "Generar propuesta", onClick: clickPropuesta, enabled: true },
    { label: "Ver propuesta", onClick: clickPropuesta },
    { label: "Propuesta Director ", onClick: clickPropuesta },
    { label: "En proceso ", onClick: clickPropuesta },
    { label: "En desarrollo", onClick: clickPropuesta },
    { label: "Cierre", onClick: clickPropuesta },
  ];
  const columns = [
    { label: "#", name: "idsolicitud", filtrar: true },
    { label: "Prioridad", name: "nprioridad", filtrar: true },
    { label: "Título", name: "titulo", filtrar: true },
    { label: "Sistema", name: "sistema", filtrar: true },
    { label: "Solicitante", name: "solicitante", filtrar: true },
    { label: "Estatus", name: "nestatus", filtrar: true },
    { label: "Fecha solicitud", name: "fcrea", filtrar: true },
  ];

  const [datosF, setDato] = React.useState({ grupo: "", year: "" });
  const [grupo, setGrupoo] = React.useState("");
  const [grupoM, setGrupooM] = React.useState({grupoM:""});

  let minOffset = 0,
    maxOffset = 4;
  let thisYear = new Date().getFullYear();
  let allYears = [];
  for (let x = 0; x <= maxOffset; x++) {
    allYears.push(thisYear - x);
  }

  const yearList = allYears.map((x) => {
    return <MenuItem value={x}>{x}</MenuItem>;
  });

  const handleChange = (event) => {
    setDato({ ...datosF, [event.target.name]: event.target.value });
    if (event.target.value)
      // serviciosSolicitudes.subgruposAll((d)=>setCtl({...ctl,idgrupo:d}),setCargando,event.target.value);
      serviciosSolicitudes.subgruposAll(
        (respuesta) => {
          setCtl({
            ...ctl,
            subgrupo: respuesta.map((vst) => vst.nsubgrupo),
            mejora: respuesta.map((vst) => vst.mejora),
            incidencia: respuesta.map((vst) => vst.incidencia),
            nuevo_modulo: respuesta.map((vst) => vst.nuevo_modulo),
          });
        },
        setCargando,
        { ...datosF, [event.target.name]: event.target.value }
      );
  };

  const handleChangeGraficaMes = (event) => {
    setGrupooM({ ...grupoM, [event.target.name]: event.target.value });
    if (event.target.value)
      // serviciosSolicitudes.subgruposAll((d)=>setCtl({...ctl,idgrupo:d}),setCargando,event.target.value);
      
      serviciosSolicitudes.graficaGrupoMes(
        (respuesta) => {
          setCtl({
            ...ctl,
            subgrupo: respuesta.map((vst) => vst.nsubgrupo),
            mejora: respuesta.map((vst) => vst.mejora),
            incidencia: respuesta.map((vst) => vst.incidencia),
            nuevo_modulo: respuesta.map((vst) => vst.nuevo_modulo),
          });
        },
        setCargando,
        { ...grupoM, [event.target.name]: event.target.value }
      );
  };

  const theme = useTheme();
  const datos = {
    labels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun"],
    datasets: [
      {
        label: "MEJORA",
        data: [33, 53, 85, 41, 44, 65],
        fill: false,
        // backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },

      {
        label: "NUEVO MÓDULO",
        data: [33, 25, 35, 51, 54, 76],
        fill: false,
        borderColor: "#742774",
      },

      {
        label: "INCIDENCIA",
        data: [20, 45, 55, 51, 57, 66],
        fill: false,
        borderColor: "#E04791",
      },
    ],
  };
  var options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            min: 0,
          },
        },
      ],
    },
  };

  const datosBarra = {
    labels: ctl.subgrupo,
    datasets: [
      {
        label: "Mejora",
        data: ctl.mejora,
        backgroundColor: "rgb(255, 99, 132)",
        stack: "Mejora",
      },
      {
        label: "Nuevo módulo",
        data: ctl.nuevo_modulo,
        backgroundColor: "rgb(54, 162, 235)",
        stack: "Nuevo módulo",
      },
      {
        label: "Incidencias",
        data: ctl.incidencia,
        backgroundColor: "rgb(75, 192, 192)",
        stack: "Incidencias",
      },
    ],
  };

  const optionsBarra = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  return (
    <Page
      className={classes.root}
      title="Panel de indicadores"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="Panel" subtitle="Indicadores" />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card>
              <CardHeader
                style={{ textAlign: "center" }}
                title="SOLICITUDES GRUPO"
              />
              {/* <Grid item md={6} xs={7} zeroMinWidth>
                <FormControl fullWidth sx={{ paddingLeft: 3, paddingRight: 3 }}>
                  <InputLabel id="demo-simple-select-outlined-label">
                    Grupo
                  </InputLabel>
                  <Select sx={{ paddingLeft: 3, paddingRight: 3 }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={grupo}
                  >
                    {ctl.grupos.map((vst) => (
                      <MenuItem value={vst.idgrupo}>{vst.ngrupo}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              */}
              <Divider />
              <CardContent>
                <Grid item md={6} xs={7}>
                  <FormControl
                    fullWidth
                    sx={{ paddingLeft: 3, paddingRight: 3 }}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Grupo
                    </InputLabel>
                    <Select
                      sx={{ paddingLeft: 3, paddingRight: 3 }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={grupo}
                      name="grupoM"
                      onChange={handleChangeGraficaMes}
                    >
                      {ctl.grupos.map((vst) => (
                        <MenuItem value={vst.idgrupo}>{vst.ngrupo}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <br />
                <Divider />
                <Box
                  // height={400}
                  position="relative"
                >
                  <Line data={datos} options={options} />
                </Box>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card>
              <CardHeader
                style={{ textAlign: "center" }}
                title="SOLICITUDES SUBGRUPO"
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <React.Fragment>
                    <Grid item md={6} xs={6}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-outlined-label">
                          Grupo
                        </InputLabel>
                        <Select
                          maxMenuHeight={190}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={datosF.grupo}
                          name="grupo"
                          onChange={handleChange}
                        >
                          {ctl.grupos.map((vst) => (
                            <MenuItem value={vst.idgrupo}>
                              {vst.ngrupo}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item md={6} xs={6}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-outlined-label">
                          Año
                        </InputLabel>
                        <Select
                          maxMenuHeight={190}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={datosF.year}
                          name="year"
                          onChange={handleChange}
                        >
                          {yearList}

                          {/* {options} */}
                        </Select>
                      </FormControl>
                    </Grid>
                  </React.Fragment>
                </Grid>
                <br />
                <Divider />
                <Box
                  // height={400}
                  position="relative"
                >
                  <Bar data={datosBarra} options={optionsBarra} />
                </Box>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Indicadores;
